export const validate = (core, defaultResinId) => {
  const warnings = [];
  const errors = [];

  const isHybrid = core !== undefined && core.resinId !== defaultResinId;

  if (isHybrid) {
    warnings.push( 'Hybrid configuration is not recommended');
  }

  return { warnings, errors }
};

export default { validate }


// WEBPACK FOOTER //
// ./src/lib/core.js